import API from './resources'
import moment from 'moment'

const actions = {
  async allLogs ({ commit }, payload) {
    try {
      const response = await API.allLogs(
        payload.page,
        payload.size,
        payload.token
      )
      commit('SET_PUSH_LIST', response)
      // commit('SET_PUSH_PAGINATION', response)
      return response
    } catch (error) {
      return error
    }
  },
  async filterLogsPush({ commit, state }, payload) {
    try {
      const response = await API.allFilterLogs(
        state.current_page,
        payload.size,
        payload.filter,
        payload.token
        )
        commit('SET_PUSH_LIST', response)
      return response
    } catch (error) {
      return error
    }
  },
  async allPushApp ({ commit, state }, payload) {
    try {

      const response = await API.allLogsPushApp(
        payload.page,
        state.page_size,
        payload.token
        )
        commit('SET_ITEMS', response)

      return response
    } catch (error) {
      return error
    }
  },
  async filterPushApp ({ commit, state }, payload) {
    try {
      const response = await API.filterLogsPushApp(
        state.current_page,
        payload.size,
        payload.filter,
        payload.token
      )
      commit('SET_ITEMS', response)
      return response
    } catch (error) {
      return error
    }
    
  },
  async getDetails({ commit }, payload) {
    let [data, token] = payload
    try {
  
      const response = await API.getLogsDetails(
       data, token
      )
  
      commit('SET_USER_ID', response)
      return response
    } catch (error) {
      return error
    }
  },
  async postLogs (_, payload) {
    let data, token
    [ data, token ] = payload
    try {

      const response = await API.postDuplicateLogs(data, token)
      return response
    } catch (error) {
      return error
    }
  },
  async filterLogs ({ commit, state }, payload) {
    const to = state.to ? moment(state.to).format('YYYY-DD-MM 00:00') : ''
    const from = state.from ? moment(state.from).format('YYYY-DD-MM 00:00') : ''
    const channel = state.logsToEdit.channelType.value ? state.logsToEdit.channelType.value : state.logsToEdit.channelType
  
    try {
      const response = await API.filter(
        state.current_page,
        state.page_size,
        state.logsToEdit.title,
        channel,
        to,
        from,
        state.logsToEdit.message,
        state.logsToEdit.smsContent,
        payload,
      )
      commit('SET_LOGS', response.data)
      return response.data
    } catch (error) {
      return error
    }
    
  },
  async getService ({commit}, payload) {
    try {
      const response = await API.getServices(
        payload.token
      )
      commit('SET_SERVICE', response.data)
      return response.data
    } catch (error) {
      return error
    }
  },
  async updateMessage(_, payload) {
    let data, token
    [ data, token ] = payload
    try {
      const response = await API.updateMessages(data, token)
      return response
    } catch (error) {
      return error
    }
  },
}

export default actions



// WEBPACK FOOTER //
// ./src/store/modules/logs/actions.js